import {Injectable} from '@angular/core';
import * as env from '../../env/current';

@Injectable()
export class Config {
  private env: any = env.default;

  public getConfig(key) {
    return this.env[key];
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/config.service.ts